import React from 'react';
import { Tooltip } from 'antd';
import RecurringIcon from "../../../../../../assets/icons/recurring.svg";
import RightArrow from "../../../../../../assets/icons/short-arrow-r.svg";
import { UnderlyingContent, TableLabel, GrantSecondaryButtonComponent, CustomisedIcon } from '../../styles';
import { milliToDate } from "../../../../../../utils/commonUtil";
import { addressFormat } from "../../../../Pages/RecommendGrant/utils";
import {removeNtee} from '../../../../../../CommonComponents/CharitySearch/utils'


export const tabPaneFuncton = (
  charityGranted,
  charitySaved,
  grantHistoryHandler,
  pendingCharityHandler,
  removeSavedCharity,
  scheduleHistoryHandler
  ) => {
    return [
        {
          title: "Recent Supported Charities",
          key: 1,
          destComponent: "table",
          mobComponent: "card",
          data: charityGranted,
          text: "No recent supported charities found",
          columnConfig: [
            {
              title: () => <div>Legal Name</div>,
              dataIndex: "charityName",
              key: "charityName",
              render: value => (<TableLabel>{value} </TableLabel>),
               width: "38%",
            },
            {
              title: () => <div>EIN</div>,
              dataIndex: "ein",
              key: "ein",
              render: (value, record) => (<UnderlyingContent onClick={() => grantHistoryHandler(record)}>{value}</UnderlyingContent>),
              width: "16%"
            },
            {
              title: () => <div>Address</div>,
              dataIndex: "location",
              key: "location",
              render: (value, record) => (<Tooltip placement="bottomLeft" title={addressFormat({
                addressLine1: record.addressLine1,
                addressLine2: record.addressLine2,
                city: record.city,
                state: record.state,
                zipCode: record.zip
              })}><UnderlyingContent>{value}</UnderlyingContent></Tooltip>),
               width: "20%"
            },
            {
              title: () => <div>Last grant issued</div>,
              dataIndex: "lastGrantDate",
              key: "lastGrantDate",
              render: value => (<TableLabel>{milliToDate(value)}</TableLabel>),
               width: "17%"
            },
            {
              title: () => <div>Interest Area</div>,
              dataIndex: "interestArea",
              key: "interestArea",
              render:   value => {
                if(value){
                  return <TableLabel>{removeNtee(value)} </TableLabel>;

                }
              },
               width: "17%"
            },
            {
              title: () => <div></div>,
              dataIndex: "isRecurring",
              key: "isRecurring",
              render: (value, record) =>  {
                return value ? (
                  <div onClick={() => scheduleHistoryHandler(record)}><img className="pointer" src={RecurringIcon} alt="RecurringIcon" /></div>
                ) : (
               ''
                )},
               width: "2%"
            },
            {
              title: () => <div></div>,
              dataIndex: "isPending",
              key: "isPending",
              render: (value, record) => {
                return <GrantSecondaryButtonComponent onClick={() => pendingCharityHandler(record)}><span className="mr1">Select</span> <img src={RightArrow} alt="RightArrow"/></GrantSecondaryButtonComponent>
              },
               width: "6%"
            }
          ]
        },
        {
          title: "Saved Charities",
          key: 2,
          destComponent: "table",
          mobComponent: "card",
          data: charitySaved,
          text: "No saved charities found",
          columnConfig: [
            {
              title: () => <div></div>,
              dataIndex: "savedCharity",
              key: "savedCharity",
              render: (value, record) => <Tooltip placement="right" title="Remove Charity"><CustomisedIcon type="star" theme="filled" onClick={(e)=> removeSavedCharity(e, record)} /></Tooltip>,
               width: "1%"
            },
            {
              title: () => <div>Legal Name</div>,
              dataIndex: "charityName",
              key: "charityName",
              render: value => (<TableLabel>{value} </TableLabel>),
              width: "36%",
            
            },
            {
              title: () => <div>EIN</div>,
              dataIndex: "ein",
              key: "ein",
              render: value => (<TableLabel>{value} </TableLabel>),
              width: "17%"
            },
            {
              title: () => <div>Address</div>,
              dataIndex: "location",
              key: "location",
              render: (value, record) => (<Tooltip placement="bottomLeft" title={addressFormat({
                addressLine1: record.addressLine1,
                addressLine2: record.addressLine2,
                city: record.city,
                state: record.state,
                zipCode: record.zip
              })}><UnderlyingContent>{value}</UnderlyingContent></Tooltip>),
              width: "20%"
            },
            {
              title: () => <div>Interest Area</div>,
              dataIndex: "interestArea",
              key: "interestArea",
              render: value => {
                if(value){ 
                  return <TableLabel>{removeNtee(value)} </TableLabel>;
                }
              },
              width: "18%"
            },
            {
              title: () => <div></div>,
              dataIndex: "isPending",
              key: "isPending",
              render: (value, record) => {
                return <GrantSecondaryButtonComponent onClick={() => pendingCharityHandler(record)}><span className="mr1">Select</span> <img src={RightArrow} alt="RightArrow"/></GrantSecondaryButtonComponent>
              },
               width: "7%"
            }
          ]
        }
      ];
}